//=include ../lib/gsap/gsap.min.js
//=include ../lib/gsap/ScrollTrigger.min.js
//=include ../lib/splitting/splitting.min.js
//=include ../lib/fancybox/jquery.fancybox.min.js
//=include ../lib/selectize/selectize.min.js
//=include ../lib/swiper/swiper-bundle.min.js
//=include ../lib/scrollTo/jquery.scrollTo.min.js
//=include ../lib/nicescroll/jquery.mCustomScrollbar.min.js
//=include ../lib/nicescroll/jquery.mousewheel.js
//=include ../lib/validator/inputmask.js
//=include ../lib/validator/jquery.inputmask.js
//=include ../lib/validator/jquery.validate.min.js
//=include ../lib/validator/parsley.min.js
//=include ../lib/validator/ru.js
//=include ../lib/form/jquery.knob.js
//=include ../lib/form/jquery.ui.widget.js
//=include ../lib/form/jquery.iframe-transport.js
//=include ../lib/form/jquery.fileupload.js
//=include ../lib/device/device.js
//=include ../lib/cookie/jquery.cookie.min.js
//=include custom.js
//=include ../all-scripts.js